import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtCaseStudySectionContainer from "./NtCaseStudySectionContainer";
import NtCaseStudyText from "./NtCaseStudyText";
import NtCaseStudyTextBold from "./NtCaseStudyTextBold";

function NtCaseStudyDisney({}) {
  return (
    <NtCaseStudySectionContainer
      style={styles.container}
      title={
        "NT Connect Maritime’s Contact Tracing Deployment On Disney Cruise Line"
      }
      image={require("../../../assets/images/partners/logo_disney.png")}
      imageStyle={{ marginLeft: -10 }}
    >
      <NtCaseStudyText>
        In March of 2020, having agreed on a partnership with Disney, NT Connect
        Maritime was scheduled to deploy their streamlined Maritime
        Communications System on the entire Disney Cruise Line fleet. NT
        Connect’s system passed all the security and quality checks and had
        already been deployed on the Disney Dream ship, so it was ready to be
        deployed fleetwide. However, during one of the initial Disney Dream
        departures with the new system deployed, The U.S. State Department
        issued a No Sail warning due to the outbreak of COVID-19, and Disney was
        forced to cancel subsequent voyages. During the shutdown, Disney worked
        with NT Connect Maritime for a solution needed on short notice,
        exploring contact tracing as a new and innovative solution.{"\n\n"}
        <NtCaseStudyTextBold>
          Testing and deployment on UK cruises
        </NtCaseStudyTextBold>
        {"\n\n"}Once the option to deploy the communications system fleetwide
        was put on hold, NT Connect Maritime sprang into action to develop a
        customized system with gateways and wearables to support contact tracing
        for both passengers and crew. Disney initially tested the system in
        their lab in Orlando, Florida. Having passed the security tests, which
        are amongst the most stringent in the industry, NT Connect Maritime then
        had to consider how to design the contact tracing system to be deployed
        remotely. Plans continually shifted in terms of which vessels would
        install the contact tracing system first, and NT Connect Maritime was
        able to make the changes seamlessly. Disney decided it was best for the
        Disney Magic moored in the UK to be the first to host it.{"\n\n"}In
        normal circumstances, NT Connect Maritime would ship all the hardware
        required directly to the vessel. NT Connect’s engineers would install
        the gateways and software on the servers onboard. However, this was not
        possible due to the COVID restrictions from the UK Government. All the
        software was required to be deployed over the ship's satellite in the
        UK. All hardware required for contact tracing (the wearables, gateways,
        and ethernet drop points) had to be boxed up and accompanied with clear
        and concise instructions. It was a huge learning curve for the crew
        involved, but it is now all in place and ready for when the fleet is
        cleared to sail again.{"\n\n"}
        <NtCaseStudyTextBold>
          How does the contact tracing work?
        </NtCaseStudyTextBold>
        {"\n\n"}The contact tracing system functions with wearable technology
        used by passengers and crew on the cruise ship. This is in conjunction
        with strategically placed Bluetooth Low Energy gateways.
      </NtCaseStudyText>

      <NtCaseStudyText
        style={{ marginTop: 20, paddingLeft: 30, paddingRight: 30 }}
      >
        If two people are within six feet of each other for 15 minutes within 24
        hours, this counts as a contact according to CDC guidelines. In the
        event of a COVID-19 outbreak on a cruise ship, the ship administrators
        can send alerts, leveraging NT Connect’s communications system, to
        passengers and crew who have been in contact with the infected person so
        that they can isolate themselves in their cabins without a ship-wide
        lockdown.
      </NtCaseStudyText>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Conclusions on the project</NtCaseStudyTextBold>
        {"\n\n"}
        Once everyone is vaccinated, and the transmission levels for COVID-19
        decline, these kinds of contact tracing measures may not be needed but
        can be repurposed for location-based marketing services for passengers.
        For example, heat mapping passenger flows to maximize and increase point
        of sale opportunities throughout a vessel. Cruise ships will also be
        able to focus on installing NT Connect Maritime’s other more exciting
        systems, such as Voice & Video Calling, Instant Messaging and app-based
        walkie-talkie features to improve the passenger experience and crew
        welfare. Disney’s initiatives show how willing they are to go above and
        beyond to ensure the safety of their passengers and crew. NT Connect
        Maritime was eager to develop solutions in a time of crisis, enabling
        Disney to continue spreading joy even during this most difficult and
        unprecedented era the industry has ever faced. In general, both
        companies are looking forward to once again enabling technologies that
        passengers and crew members can enjoy using.
      </NtCaseStudyText>

      <Image
        style={[styles.image, { marginTop: 50 }]}
        source={require("../../../assets/images/disney-mickey-mouse.png")}
      />
    </NtCaseStudySectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {},
  image: {
    width: "100%",
    height: 250,
    resizeMode: "contain",
  },
});

export default NtCaseStudyDisney;
